import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

import {
  QUESTION_BRANCH_DATA_KEY_COMBINED,
  QUESTION_BRANCH_DATA_KEY_SEPARATED,
  QUESTION_BRANCH_DATA_KEY_UNKNOWN,
} from '/business/shared/components/pages/question/questionEnums';

export default function useDatatypeBehaviour(): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_DROPDOWN,
    label: 'Data type:',
    element: 'data_type',
    propName: 'data_type',
    values: [
      {
        name: QUESTION_BRANCH_DATA_KEY_COMBINED,
        displayName: 'Scope 1 and 3 (combined)',
      },
      {
        name: QUESTION_BRANCH_DATA_KEY_SEPARATED,
        displayName: 'Scope 1 and 3 (separated)',
      },
      {
        name: QUESTION_BRANCH_DATA_KEY_UNKNOWN,
        displayName: "I don't know",
      },
    ],
    getPropValue: (answer) => answer.genericData?.data_type,
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNODATATYPE',
        errStr: t('business:Errors.supplierForm.dataType'),
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERRDATATYPENOTFOUND',
        errStr: t('business:Errors.supplierForm.dataTypeNotFound'),
      },
    ],
  };
}
